import React from "react";
import { Authenticator, Heading } from "@aws-amplify/ui-react";
// eslint-disable-next-line import/no-unresolved
import "@aws-amplify/ui-react/styles.css";
import { initAmplify } from "../../services/amplify";
import "../assets/amplify.css";

initAmplify();

const components = {
  Header() {
    return (
      <Heading marginBottom="2rem" level={1} textAlign="center">
        User management
      </Heading>
    );
  },
};

const UserManagementAuthenticator = ({ children }) => (
  <Authenticator hideSignUp components={components}>
    {() => children}
  </Authenticator>
);

export default UserManagementAuthenticator;
